export function injectComma(num: number): string {
  return `${num}`.replaceAll(/\B(?=(\d{3})+(?!\d))/g, ',')
}
